import withWidth from '@mui/material/Hidden/withWidth'
import { observer } from 'mobx-react'
import React from 'react'
import { CheckboxStore } from '../../../stores/CheckboxStore'
import NewPaginationStore from '../../../stores/NewPaginationStore'
import MassChangePaymentType from '../components/MassChangeTypeSubsidy/MassChangePaymentType'
import NewAssignDealerDrawer from '../components/MassOperationDrawer/NewAssignDealerDrawer'
import DealerTabbedTableView from '../components/NewRequestsTable/DealerTabbedTableView'
import RequestsTableFilterStore from '../components/NewRequestsTable/stores/RequestsTableFilterStore'
import NewResetToCreateDrawer from '../components/NewResetToCreateDrawer/NewResetToCreateDrawer'

export const adminRequestsPaginationStore = new NewPaginationStore({})
export const adminRequestsFiltersStore = new RequestsTableFilterStore()
export const adminRequestsCheckboxStore = new CheckboxStore()

const AdminRequestPage = () => {
  return (
    <>
      <DealerTabbedTableView
        paginationStore={adminRequestsPaginationStore}
        filtersStore={adminRequestsFiltersStore}
        checkboxStore={adminRequestsCheckboxStore}
      />
      <NewAssignDealerDrawer />
      <NewResetToCreateDrawer />
      <MassChangePaymentType />
    </>
  )
}

export default withWidth()(observer(AdminRequestPage))
